<app-nav></app-nav>
<main class="landing-main">
    <section>
        <app-terms-and-conditions-content/>
    </section>
    <div class="btn-cont">
        <a routerLink="/" class="button-primary">
            Volver Atrás
        </a>
    </div>
</main>
<app-footer />
